
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/topBar/dropPanel/promotionalPanel/linksList.scss.css.virtualfile';
        module.exports = {"linksListItem":"_linksListItem_1sezl_7","text":"_text_1sezl_13","symbolContainer":"_symbolContainer_1sezl_17"};